
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import InteractivePACTsCarousel from '@/components/InteractivePACTsCarousel';

const HeroSection = () => {
  return (
    <section className="container max-w-6xl mx-auto px-4 py-20">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-center lg:text-left">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-soft/50 text-blue-primary rounded-full text-sm font-medium mb-8 border border-blue-primary/20">
            <div className="w-2 h-2 bg-blue-primary rounded-full animate-pulse-gentle"></div>
            Limited spots available
          </div>

          <h2 className="text-5xl md:text-6xl font-bold text-slate-dark mb-6 leading-tight font-display">
            Before You Build
            <span className="text-transparent bg-gradient-to-r from-blue-primary to-orange-accent bg-clip-text block">
              Your Next Goal
            </span>
          </h2>
          <p className="text-xl text-slate-lighter mb-8 leading-relaxed max-w-xl lg:max-w-none">
            Start with curiosity. Create your first PACT and discover what showing up really means.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button
              className="bg-gradient-to-r from-blue-primary to-blue-light hover:from-blue-light hover:to-blue-primary text-white rounded-xl px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-glow"
            >
              Join the Waitlist Now
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              variant="outline"
              className="border-slate-light text-slate-medium hover:bg-slate-dark hover:text-white rounded-xl px-8 py-4 text-lg transition-all duration-300"
            >
              See How It Works
            </Button>
          </div>
        </div>

        <div className="flex justify-center lg:justify-end">
          <div className="relative">
            <InteractivePACTsCarousel />
            
            {/* Floating decorative elements */}
            <div className="absolute -top-8 -left-8 w-20 h-20 bg-gradient-to-br from-orange-accent/20 to-transparent rounded-full blur-xl animate-pulse-gentle"></div>
            <div className="absolute -bottom-8 -right-8 w-24 h-24 bg-gradient-to-tr from-blue-primary/20 to-transparent rounded-full blur-xl animate-pulse-gentle delay-1000"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
